import { createLocalStorage } from '@/utils/cache'

const ls = createLocalStorage()
// 设置token
export function setCache(key: string, value: any) {
  ls.set(key, value)
}
// 获取token
export function getCache(key: string) {
  return ls.get(key)
}
// 删除token
export function removeCache(key: string) {
  return ls.remove(key)
}
